import React from 'react';
export function scheduleClock(seconds) {
    if (seconds == null || !Number.isFinite(seconds)) return 'Sin datos';
    const minutes = Math.ceil(seconds / 60);
    const day = Math.floor(minutes / 1440);
    return String(Math.floor(minutes / 60) % 24).padStart(2, '0') + ':' + String(minutes % 60).padStart(2, '0') + (day ? ' (+' + day + ' día)' : '');
}
export default function RouteScheduleSummary({ schedule, stale }) {
    if (!schedule?.configured) return <p>Horarios y jornada opcionales, sin configurar. No bloquean el envío.</p>;
    return <section aria-label="Horario estimado" className="mt-3">
        <h4>Horario estimado · Panamá</h4>
        <p>Horarios y jornada opcionales. Estos avisos no bloquean el envío.</p>
        {stale ? <p>Hay cambios sin guardar. El horario mostrado corresponde al último plan guardado.</p> : null}
        {(schedule.problems || []).map((message, index) => <p className="text-orange-700" key={'p' + index}>{message}</p>)}
        {(schedule.warnings || []).map((message, index) => <p className="text-orange-700" key={'w' + index}>{message}</p>)}
        <div style={{ overflowX: 'auto' }}><table className="w-full"><thead><tr>
            <th>Parada</th><th>Llegada</th><th>Inicio atención</th><th>Salida</th><th>Atención</th><th>Espera</th><th>Acceso</th>
        </tr></thead><tbody>{(schedule.stops || []).map(stop => <tr key={stop.location_id}>
            <td>{stop.name}</td><td>{scheduleClock(stop.arrival_seconds)}</td><td>{scheduleClock(stop.service_start_seconds)}</td><td>{scheduleClock(stop.departure_seconds)}</td>
            <td>{Math.ceil(stop.service_seconds / 60)} min</td><td>{Math.ceil(stop.waiting_seconds / 60)} min</td>
            <td>{stop.window ? stop.window.opens + '–' + stop.window.closes : 'Sin confirmar'}{stop.outside_window ? ' · Fuera de horario' : ''}</td>
        </tr>)}</tbody></table></div>
        <p>Fin estimado, incluido regreso y cierre en bodega: <b>{scheduleClock(schedule.finish_seconds)}</b>.</p>
        <small>Estimación del recorrido guardado; el orden no se modifica automáticamente para cumplir horarios.</small>
    </section>;
}
